<template>
    <v-card flat rounded="20" class="mb-5 pb-0" :color="setBgColor()">
        <div
            class="px-5 pb-5"
            :class="data.badge || tribun_source_status ? 'pt-5' : 'pt-0 pb-10'"
        >
            <div class="mb-1" style="height: 18px">
                <v-btn
                    v-if="data.badge === 'BEST_VALUES'"
                    variant="flat"
                    size="small"
                    color="blew"
                    class="text-white rounded-xl px-2 pr-3 mr-1"
                >
                    <v-icon color="#eeac16" class="mr-1">mdi-star</v-icon>

                    Pilihan Terbaik
                </v-btn>

                <v-btn
                    v-if="data.badge === 'MOST_PURCHASED'"
                    variant="outlined"
                    size="small"
                    color="red"
                    class="rounded-xl px-2 pr-3 mr-1"
                    style="border: 1.8px solid red"
                >
                    <v-icon color="red" class="mr-1">mdi-heart</v-icon>

                    Banyak Dibeli
                </v-btn>

                <v-btn
                    v-if="data.badge === 'RECOMMENDED'"
                    variant="outlined"
                    size="small"
                    color="#f27817"
                    class="rounded-xl px-2 pr-3 mr-1"
                    style="border: 1.8px solid #f27817"
                >
                    <v-icon color="#f27817" class="mr-1">mdi-thumb-up</v-icon>

                    Rekomendasi
                </v-btn>

                <!-- <v-btn
                    v-if="tribun_source_status"
                    variant="flat"
                    size="small"
                    color="#016fba"
                    class="rounded-xl px-2 pr-3"
                >
                    <v-img
                        :src="require('@/assets/images/tribun.png')"
                        :height="15"
                        :width="16"
                        class="mr-1"
                    />

                    Tribunnews
                </v-btn> -->
            </div>

            <div
                class="font-weight-600 font-size-18 text-darkblue py-3 line-height-24 ellipsis-2"
                style="min-height: 70px"
            >
                {{ data.name }}
            </div>

            <div class="text-blacknew font-size-14 mt-1">
                Berlaku selama {{ package_periode }}
            </div>
        </div>

        <div
            class="px-4 pt-5 bg-white"
            style="border-radius: 20px 20px 0px 0px"
        >
            <v-virtual-scroll
                :items="features"
                :height="discount_status && data.discount_exp_time ? 174 : 223"
                item-height="36"
                class="custom-scroll"
            >
                <template v-slot:default="{ item, index }">
                    <div class="d-flex gap-10 mb-2" :key="index">
                        <div>
                            <img
                                :src="
                                    require('@/assets/icons/checklist-blue.svg')
                                "
                            />
                        </div>
                        <div
                            class="font-size-14 text-blacknew"
                            v-html="item"
                        ></div>
                    </div>
                </template>
            </v-virtual-scroll>

            <hr class="my-5 dashed" />

            <div v-if="discount_status && data.discount_exp_time">
                <div
                    class="d-flex align-center justify-space-between bg-chilired text-white rounded-9 px-3 py-2 font-weight-600 font-size-14"
                >
                    <div class="d-flex align-center gap-10">
                        <img :src="require('@/assets/icons/lightning.svg')" />
                        <div>Diskon Berakhir dalam</div>
                    </div>
                    <div>{{ countdown }}</div>
                </div>
            </div>

            <div v-if="discount_status" class="d-flex align-center gap-10 mt-3">
                <v-chip
                    rounded="5"
                    class="px-2 py-1 font-weight-600 text-chilired"
                    color="lightred"
                >
                    {{ data.discount }}%
                </v-chip>

                <div class="text-chilired font-size-18 font-weight-600">
                    Rp {{ formatNumber(data.actual_price) }}
                </div>

                <div
                    class="text-darkgrey font-size-14 font-weight-400"
                    style="text-decoration: line-through"
                >
                    Rp {{ formatNumber(data.normal_price) }}
                </div>
            </div>

            <div v-else>
                <div class="text-chilired font-size-18 font-weight-600">
                    Rp {{ formatNumber(data.normal_price) }}
                </div>
            </div>
        </div>

        <v-card-actions class="py-5 px-4 bg-white">
            <v-btn
                color="#0e97d6"
                variant="flat"
                rounded="pill"
                block
                @click="$emit('detail')"
            >
                Beli Paket
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            countdown: '00 : 00 : 00 : 00',
            timer: null,
        };
    },

    computed: {
        features() {
            const feature_package = this.data.feature_package || '';
            const matches = feature_package.match(/<li>(.*?)<\/li>/g);

            const data = matches
                ? matches.map((item) => item.replace(/<\/?li>/g, ''))
                : [];

            return data;
        },

        package_periode() {
            const package_type = this.data.type;
            let package_periode = null;

            if (package_type === 'ANNUALLY') {
                package_periode = '1 tahun';
            }

            if (package_type === 'NINE_MONTH') {
                package_periode = '9 Bulan';
            }

            if (package_type === 'SIX_MONTH') {
                package_periode = '6 Bulan';
            }

            if (package_type === 'THREE_MONTH') {
                package_periode = '3 Bulan';
            }

            if (package_type === 'MONTHLY') {
                package_periode = '1 Bulan';
            }

            return package_periode;
        },

        discount_status() {
            const discount = this.data.discount;
            const discount_exp_time = this.data.discount_exp_time;
            const now = this.$moment();
            let status = true;

            if (discount_exp_time) {
                if (this.$moment(discount_exp_time).isAfter(now)) {
                    status = true;
                } else {
                    status = false;
                }
            }

            if (!discount) {
                status = false;
            }

            return status;
        },

        tribun_source_status() {
            const ref = Cookies.get('url_referrer_source') || '';
            // ref.includes('tribunnews')

            return ref;
        },
    },

    beforeUnmount() {
        clearInterval(this.timer);
    },

    mounted() {
        this.startCountdown();
    },

    methods: {
        formatNumber(val = 0) {
            return val.toLocaleString('id-ID');
        },

        setBgColor() {
            const package_type = this.data.type;
            let package_color = '#ffcccf';

            if (package_type === 'ANNUALLY') {
                package_color = '#ffcccf';
            }

            if (package_type === 'NINE_MONTH') {
                package_color = '#DCEDC8';
            }

            if (package_type === 'SIX_MONTH') {
                package_color = '#fbefb2';
            }

            if (package_type === 'THREE_MONTH') {
                package_color = '#bcf8cc';
            }

            if (package_type === 'MONTHLY') {
                package_color = '#e1f4fc';
            }

            if (package_type === 'WEEKLY') {
                package_color = '#e1f4fc';
            }

            return package_color;
        },

        startCountdown() {
            const end = this.$moment(this.data.discount_exp_time);

            this.timer = setInterval(() => {
                const now = this.$moment();
                const duration = this.$moment.duration(end.diff(now));

                if (duration.asMilliseconds() <= 0) {
                    clearInterval(this.timer);
                    this.countdown = '00 : 00 : 00 : 00';
                    return;
                }

                const days = String(duration.days()).padStart(2, '0');
                const hours = String(duration.hours()).padStart(2, '0');
                const minutes = String(duration.minutes()).padStart(2, '0');
                const seconds = String(duration.seconds()).padStart(2, '0');

                this.countdown = `${days} : ${hours} : ${minutes} : ${seconds}`;
            }, 1000);
        },
    },
};
</script>

<style scoped>
.custom-scroll {
    padding-right: 6px;
    overflow-y: auto;
}

/* Webkit browsers (Chrome, Safari, Edge) */
.custom-scroll::-webkit-scrollbar {
    width: 10px; /* ⬅️ lebih tebal */
}
.custom-scroll::-webkit-scrollbar-track {
    background: transparent;
}
.custom-scroll::-webkit-scrollbar-thumb {
    background-color: #cfd8dc;
    border-radius: 8px; /* bisa dibesarkan biar lebih bulat */
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
    background-color: #90a4ae;
}

/* Firefox */
.custom-scroll {
    scrollbar-width: auto; /* auto = lebih tebal daripada thin */
    scrollbar-color: #cfd8dc transparent;
}

.ellipsis-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* maksimal 2 baris */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    line-height: 1.5em; /* tinggi per baris */
    max-height: 3em;
}
</style>
